// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"22":"1ebd1352","186":"7f42c0a2","272":"12d27837","372":"d5b2cbac","377":"21e4d973","738":"756f9b77","841":"1b58c82e","851":"9b9d7286","856":"d94089eb"}[chunkId] + ".chunk.js";
};